/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `ParticipantUserRow` for the Caintra Connect frontend.
 * @module components/B2BEventParticipatingCompanyForm/ParticipantUserRow
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { ReactComponent as PlusIcon } from "../../assets/icons/B2BEvents/PlusIcon.svg";
import ParticipantScheduleRow from "./ParticipantScheduleRow.jsx";

const ParticipantUserRow = ({
  user,
  selected,
  schedules,
  userEntries,
  eventDateStart,
  eventDateEnd,
  eventTimeStart,
  eventTimeEnd,
  onCheckboxChange,
  onScheduleChange,
  onRemoveSchedule,
  onAddSchedule,
  styles,
  t,
}) => {
  const userId = user._id || user.id;

  return (
    <div key={userId || user.nombre} className={styles.participantUserRowWrapper}>
      <div className={styles.participantUserRow}>
        <input
          type="checkbox"
          id={`user-${userId}`}
          className={styles.userCheckbox}
          checked={selected}
          aria-labelledby={`user-name-${userId}`}
          onChange={() => onCheckboxChange(user)}
        />
        <span id={`user-name-${userId}`} className={styles.participantUserName}>
          {user.nombre}
        </span>
      </div>
      {selected && (
        <div className={styles.participantUserEditSection}>
          {schedules.map((schedule, scheduleIndex) => (
            <ParticipantScheduleRow
              key={`${userId}-${scheduleIndex}`}
              userId={userId}
              scheduleIndex={scheduleIndex}
              schedule={schedule}
              entry={userEntries[scheduleIndex]}
              schedulesCount={schedules.length}
              eventDateStart={eventDateStart}
              eventDateEnd={eventDateEnd}
              eventTimeStart={eventTimeStart}
              eventTimeEnd={eventTimeEnd}
              onScheduleChange={onScheduleChange}
              onRemoveSchedule={onRemoveSchedule}
              styles={styles}
              t={t}
            />
          ))}
          <div className={styles.addNewDateButtonWrapper}>
            <button
              type="button"
              className={styles.addNewDateButton}
              onClick={() => onAddSchedule(userId)}
            >
              <PlusIcon />
              {t("pages.b2bEventForm.addNewDate")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipantUserRow;
